 (function() {
    class GwtMultiColumnGrid extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.setupButtonHovers();
      }

      setupButtonHovers() {
        const buttons = this.querySelectorAll('.gwt-custom-columns-button');
        
        buttons.forEach(button => {
          const hoverBg = button.getAttribute('data-hover-bg');
          const hoverText = button.getAttribute('data-hover-text');
          const defaultBg = button.getAttribute('data-default-bg');
          const defaultText = button.getAttribute('data-default-text');

          button.addEventListener('mouseenter', function() {
            this.style.backgroundColor = hoverBg;
            this.style.color = hoverText;
          });

          button.addEventListener('mouseleave', function() {
            this.style.backgroundColor = defaultBg;
            this.style.color = defaultText;
          });
        });
      }
    }

    customElements.define('gwt-multi-column-grid', GwtMultiColumnGrid);
  })();